import { SwitchLang } from "@/components/example/switch-lang";
import Logo from "@/components/shared/logo";
import CloseIcon from "@/components/ui/close-icon";
import { Dispatch, SetStateAction } from "react";

type TitleBarProps = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export default function TitleBar({ setIsOpen }: TitleBarProps) {
  return (
    <div className="flex items-center justify-between">
      <Logo />
      <div className="flex items-center gap-3">
        <SwitchLang />
        <CloseIcon
          className="my-auto flex h-9 w-9 items-center justify-center rounded-full border-2 border-[#F3D5A9]/30 bg-transparent text-sm leading-none sm:h-12 sm:w-12 sm:text-xl xl:hidden"
          onClick={() => setIsOpen(false)}
        />
      </div>
    </div>
  );
}
